<script lang="ts">
  import RequestItemTooltip from "@shared/svelte/Components/RequestableItems/RequestItemTooltip.svelte";
  import LimitedOrderingProductRequestModal from "@retailer/svelte/ProductDetails/Components/LimitedOrderingProductRequestModal.svelte";

  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  export let cartWidgetItem: any;

  let open: boolean = false;

  let product: any;
  let productLine: any;
  let distributor: any;

  const load = async () => {
    try {
      const response = await HttpPromise({
        method: "GET",
        url: `/api/retailer/requested_items/${cartWidgetItem.inventory_id}`,
      });
      product = response.product_summary;
      productLine = response.product_line_summary;
      distributor = response.distributor_summary;
    } catch (error) {
      console.error(error, "error");
    }
  };

  $: requestable =
    cartWidgetItem.quantity_restrictions?.additional_action ===
    "quantity_restrictions.request_item";

  $: needsApproval = cartWidgetItem.mandate_list?.additional_action === "mandate_list.request_item";
  $: requestedApproval =
    cartWidgetItem.mandate_list?.additional_action === "mandate_list.view_request";
</script>

<div class="craft">
  {#if needsApproval || requestedApproval}
    {#if requestable}
      <RequestItemTooltip bind:distributor bind:product />
    {/if}
    <button
      data-testid="request-item-btn"
      class="fizz-button fizz-full-width"
      disabled={requestedApproval}
      on:click={async () => {
        await load();
        open = true;
      }}
    >
      Request Approval
    </button>
  {:else}
    <slot />
  {/if}
</div>

<LimitedOrderingProductRequestModal bind:open bind:product bind:productLine bind:requestable />
